import { render, staticRenderFns } from "./RiesgoOperativo.vue?vue&type=template&id=5bd4f280&"
import script from "./RiesgoOperativo.vue?vue&type=script&lang=js&"
export * from "./RiesgoOperativo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports